import { render } from "./QGoogleDownload.vue?vue&type=template&id=2ce1cf14"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QGoogleDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ce1cf14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ce1cf14', __exports__)) {
    api.reload('2ce1cf14', __exports__)
  }
  
  module.hot.accept("./QGoogleDownload.vue?vue&type=template&id=2ce1cf14", () => {
    api.rerender('2ce1cf14', render)
  })

}


export default __exports__